import { SepaFieldNames } from "checkout-query-client/types/chex-form-fields";
import { FormConfig } from "checkout-query-client/types/form-types";

export const lpmFormConfig: FormConfig<SepaFieldNames> = {
  active: true,
  title: "",
  inputs: [],
};
